import { observer } from 'mobx-react';
import React, { useRef } from 'react';
import { SimpleFeature } from '@jbrowse/core/util';
import { PrerenderedCanvas } from '@jbrowse/core/ui';
const MultiWiggleRendering = observer(function (props) {
    const { regions, features, bpPerPx, width, height, sources, onMouseLeave = () => { }, onMouseMove = () => { }, onFeatureClick = () => { }, displayModel, } = props;
    const [region] = regions;
    const ref = useRef(null);
    function getFeatureUnderMouse(eventClientX, eventClientY) {
        if (!ref.current) {
            return;
        }
        const rect = ref.current.getBoundingClientRect();
        const offsetX = eventClientX - rect.left;
        const offsetY = eventClientY - rect.top;
        const source = sources[Math.floor((offsetY / height) * sources.length)];
        if (!source) {
            return;
        }
        const px = region.reversed ? width - offsetX : offsetX;
        const mouseoverBp = region.start + bpPerPx * px;
        let featureUnderMouse;
        if (displayModel.isMultiRow) {
            for (const feature of features.values()) {
                if (feature.get('source') !== source.name) {
                    continue;
                }
                if (mouseoverBp <= feature.get('end') + bpPerPx &&
                    mouseoverBp >= feature.get('start')) {
                    featureUnderMouse = feature;
                    break;
                }
            }
        }
        else {
            const featuresUnderMouse = [];
            for (const feature of features.values()) {
                if (mouseoverBp <= feature.get('end') + bpPerPx &&
                    mouseoverBp >= feature.get('start')) {
                    featuresUnderMouse.push(feature);
                }
            }
            if (featuresUnderMouse.length) {
                const pos = Math.floor(mouseoverBp);
                featureUnderMouse = new SimpleFeature({
                    uniqueId: 'mouseoverfeat',
                    sources: Object.fromEntries(featuresUnderMouse
                        .map(f => f.toJSON())
                        .map(f => {
                        const { refName, start, end, source, ...rest } = f;
                        return [source, rest];
                    })),
                    ...region,
                    start: pos,
                    end: pos + 1,
                });
            }
        }
        return featureUnderMouse;
    }
    return (React.createElement("div", { ref: ref, onMouseMove: event => {
            const { clientX, clientY } = event;
            const featureUnderMouse = getFeatureUnderMouse(clientX, clientY);
            onMouseMove(event, featureUnderMouse);
        }, onClick: event => {
            const { clientX, clientY } = event;
            const featureUnderMouse = getFeatureUnderMouse(clientX, clientY);
            onFeatureClick(event, featureUnderMouse);
        }, onMouseLeave: event => onMouseLeave(event), style: {
            overflow: 'visible',
            position: 'relative',
            height,
        } },
        React.createElement(PrerenderedCanvas, { ...props })));
});
export default MultiWiggleRendering;
